/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Styled for Simple Table Component
 *
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../theme';

interface ISimpleTableStyled {
    bordered?: boolean;
    maxHeight?: string;
}

export const SimpleTableRowStyled = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;

    border-bottom: 1px solid ${colors.borderColorSeparate};
    justify-content: space-between;
    align-items: center;
`;

interface ISimpleTableCellStyled {
    align?: string;
    flex?: number;
    width?: number;
}

export const SimpleTableCellStyled = styled.div<ISimpleTableCellStyled>`
    text-align: ${props => props.align ? props.align : 'left'};

    // calc width
    ${props => props.width ? `flex-basis: ${props.width}px` : 'flex-grow: 1;'};

    // flex
    ${props => props.flex ? `flex-grow: ${props.flex};` : ''}

    padding-top: 12px;
    padding-bottom: 12px;

    &:not(:first-child) {
        padding-left: 16px;
    }
`;

export const SimpleTableHeaderRowStyled = styled(SimpleTableRowStyled)`
    color: ${colors.textColorOpacity};
`;

export const SimpleTableStyled = styled.div.attrs(({ bordered }: ISimpleTableStyled) => ({
    className: `${bordered ? 'simple-table--bordered' : ''}`,
}))<ISimpleTableStyled>`

    ${props => props.maxHeight ? `
        max-height: ${props.maxHeight};
        overflow: auto;
    ` : ''}
    &.simple-table--bordered {
        border: 1px solid ${colors.borderColorSeparate};
        border-top: none;

        ${SimpleTableHeaderRowStyled} {
            background: ${colors.backgroundColorModal};

            position: sticky;
            top: 0;
            z-index: 1;

            border-top: 1px solid ${colors.borderColorSeparate};
            box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.2);

            ${SimpleTableCellStyled} {
                padding-top: 32px;
                padding-bottom: 24px;

                ${fonts.textSmall}
                color: ${colors.textColorOpacity};
            }
        }

        ${SimpleTableRowStyled} {
            &:last-child {
                border-bottom: none;
            }
        }

        ${SimpleTableCellStyled} {
            &:first-child {
                padding-left: 24px;
            }

            &:last-child {
                padding-right: 24px;
            }
        }
    }
`;
